import {
    MultiSelect,
    MultiSelectValue,
    ListLoaderParams
} from './interface';

import { LoadingStatus } from '@/types/common';

import { defaultParamsFormatter } from '@/components/select/utils';

import { getList } from '@/api/crud';

export default class MultiselectEntity {
    entityName: string;
    entity: MultiSelect;

    constructor(name: string) {
        this.entity = {
            name,
            title: '',
            list: [],
        };
        this.entityName = name;
    }

    setTitle(title: string) {
        this.entity.title = title;

        return this;
    }

    setDisabled(disabled: boolean) {
        this.entity.disabled = disabled;
    }

    setItems(items: MultiSelectValue[]) {
        this.entity.list = items;

        return this;
    }

    setListLoader(params: ListLoaderParams) {
        const loader = {
            status: LoadingStatus.Idle,
            load: async (query = '') => {
                loader.status = LoadingStatus.Loading;

                const filter = defaultParamsFormatter(query, 'title');

                try {
                    const page = 1;

                    const response = await getList(params.moduleName, { page: page, items: 50 }, '', filter);
                    const items = Array.isArray(response)
                        ? response :
                        response?.table?.rows ?? [];

                    this.entity.list = items.map((item: any) => ({
                        id: item.id,
                        value: item.title,
                    }));

                    if (response?.table?.totalItems > (page * 50)) {
                        await this._loadNextPage(params.moduleName, page + 1, filter);
                    }

                    loader.status = LoadingStatus.Loaded;
                } catch (error) {
                    console.log(error);
                    loader.status = LoadingStatus.Error;
                }
            }
        };

        this.entity.listLoader = loader;

        return this;
    }

    async _loadNextPage(entityName: string, page: number, filter?: string) {
        try {
            const response = await getList(entityName, { page: page, items: 50 }, '', filter);
            const items = Array.isArray(response)
                ? response :
                response?.table?.rows ?? [];

            const loadingItems = items.map((item: any) => ({
                id: item.id,
                value: item.title,
            }));

            this.setItems([...this.entity.list, ...loadingItems]);

            if (response?.table?.totalItems > (page * 50)) {
                await this._loadNextPage(entityName, page + 1, filter);
            }
        } catch (error) {
            console.log(error);
        }
    }
}
